import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { RecommendedFollowsUserCell } from '@components/RecommendedFollows/UserCell';
import { UserCellSkeleton } from '@components/RecommendedFollows/UserCellSkeleton';
import { TrendingRecommendedFollowsDocument, useQuery } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  query TrendingRecommendedFollows {
    trendingPostsRecommendedFollows {
      ...RecommendedFollowsUserCell
    }
  }
`);

export function TrendingRecommendedFollowsSkeleton() {
  return (
    <>
      <UserCellSkeleton />
      <UserCellSkeleton />
      <UserCellSkeleton />
      <UserCellSkeleton />
      <UserCellSkeleton />
      <UserCellSkeleton />
    </>
  );
}

/**
 * This component is only visible on LT+ screens
 */
export function TrendingRecommendedFollows() {
  const { data, isLoading } = useQuery(TrendingRecommendedFollowsDocument, { staleTime: Infinity });

  if (!isLoading && !data?.data.trendingPostsRecommendedFollows.length) {
    return null;
  }

  const peopleUsers = data?.data.trendingPostsRecommendedFollows;

  return (
    <div className="hidden w-full flex-00auto flex-col gap-8 lt:flex">
      <div>
        <div className="mb-4 line-clamp-1 font-title text-title-s font-medium text-base800">
          People to follow
        </div>
        <div className="flex flex-col gap-3">
          {isLoading ? (
            <TrendingRecommendedFollowsSkeleton />
          ) : (
            peopleUsers?.map((user, idx) => (
              <RecommendedFollowsUserCell
                key={`feed-recommended-follows-people-user-cell-${idx}`}
                userFrag={user}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
}
